import React from 'react';
import { PermisionDenied } from '../../views/pages/manage/common/commonComponents';
import { useGetPermissions } from '../../layouts/customHook';
import BulkPaymentTransfer from './BulkPaymentTransfer';

const BulkPaymentTransferAccessGuard = () => {

    const userPermissions = useGetPermissions("bulkPaymentTransfer");
    
    return (  
        userPermissions
        ? <BulkPaymentTransfer userPermissions={userPermissions}/>
        : <PermisionDenied/>
    );
}
 
export default BulkPaymentTransferAccessGuard;